<script lang="ts">
    
    import type { Readable, Writable } from "svelte/store";
    import type { State } from "../Model/State";

    export let store: Writable<any> | Readable<any> | State;

    $: value = $store;

</script>

<slot {value}>{value}</slot>
